import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import _ from "lodash";
import { actuatorLabel } from "app/shared/automations/controlLoopDisplay";
import { clock, stateLabel } from "app/shared/devices/actuatorDisplay";
import SummaryChip from "../../components/SummaryChip";

// Chips de la tarjeta de un límite: la condición y cuántas salidas protege.
export const SafetyLimitCardSummary = ({ item, compact = false }) => {
    const limit = item.data || {};
    const outputs = limit.outputs || [];

    return (
        <>
            <SummaryChip icon={<ShieldOutlinedIcon />} label={limit.condition_label} color={limit.tripped ? "error" : "default"} />
            <SummaryChip
                icon={<PowerSettingsNewOutlinedIcon />}
                label={compact || outputs.length > 1 ? `${outputs.length} salida${outputs.length === 1 ? "" : "s"}` : outputs[0]?.name}
                color="warning"
            />
        </>
    );
};

export const safetyLimitStatusChip = (item) => {
    const limit = item.data || {};
    if (!limit.enabled) return null;
    if (limit.tripped) return { label: `Activo desde las ${clock(limit.tripped_at)}`, color: "error" };
    return null;
};

export const safetyLimitSubtitle = (item) => {
    const limit = item.data || {};
    if (item.description) return item.description;
    if (limit.tripped && limit.trip_reason) return `Activo: ${limit.trip_reason}`;
    return `${limit.condition_label} en «${limit.sensor?.name || "su sensor"}»`;
};

const DetailBox = ({ title, children }) => (
    <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2.5, flex: 1, bgcolor: "rgba(15, 23, 42, 0.02)" }}>
        <Typography variant="caption" color="text.secondary" fontWeight={700}>{title}</Typography>
        <Stack spacing={0.4} sx={{ mt: 0.75 }}>{children}</Stack>
    </Paper>
);

export const SafetyLimitCardDetails = ({ item }) => {
    const limit = item.data || {};

    return (
        <Stack direction={{ xs: "column", lg: "row" }} spacing={1.25} sx={{ pt: 1.5 }}>
            <DetailBox title="Se activa">
                <Typography variant="body2">{limit.condition_label} en <b>{limit.sensor?.name}</b></Typography>
                <Typography variant="caption" color="text.secondary">
                    {limit.trip_when_stale
                        ? `También si el sensor pasa ${limit.stale_after_minutes} min sin informar`
                        : "Si el sensor deja de informar, no hace nada"}
                </Typography>
            </DetailBox>
            <DetailBox title="Protege">
                {(limit.outputs || []).map((output) => (
                    <Typography key={`output-${output.id}`} variant="body2">
                        <b>{actuatorLabel(output)}</b>: {stateLabel(output.effective_state)}
                        {output.controlled_by ? ` · la maneja «${output.controlled_by.name}»` : ""}
                    </Typography>
                ))}
            </DetailBox>
            <DetailBox title="Estado">
                <Typography variant="body2" color={limit.tripped ? "error.main" : "text.primary"}>
                    {!limit.enabled ? "Pausado" : limit.tripped ? `Activo: ${limit.trip_reason}` : "Dentro del límite"}
                </Typography>
                {limit.last_evaluated_at && (
                    <Typography variant="caption" color="text.secondary">Revisado a las {clock(limit.last_evaluated_at)}</Typography>
                )}
                {!limit.last_evaluated_at && limit.enabled && (
                    <Typography variant="caption" color="text.secondary">Todavía sin revisar</Typography>
                )}
                {!_.isEmpty(limit.recipients) && (
                    <Typography variant="caption" color="text.secondary">
                        Avisa a {limit.recipients.map((recipient) => recipient.user_name).join(", ")}
                    </Typography>
                )}
            </DetailBox>
        </Stack>
    );
};
